export default function Page404() {
  return (
    <div className="flex-col h-[75vh] text-white gap-2 overflow-auto content-center justify-center text-center">
      <div className="text-9xl mb-2">404</div>
      <div className="text-3xl mb-2">Page not found</div>
    </div>
  )
}
